<template>
  <v-layout row style="padding-top:49px;"   fill-height>
    <v-snackbar
        v-model="snackbar"
        color="info"
        :timeout="3000"
        :top="true"
      >
        {{ snakText }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar  v-model="error" color="error" :timeout="3000" top="top">
      {{errorMsg}}
    </v-snackbar>
    <v-dialog persistent v-model="dialogUploadList" scrollable width="1200">
      <v-card class="dialog_card">
        <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-2" primary-title>
          Uploaded items
           <div class="flex-grow-1"></div>

          <v-btn icon light @click="dialogUploadList = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
          <v-container>
                <v-row dense>
                      <v-col cols="12">
                          <v-list>
                            <v-list-item
                                    v-for="(item, i) in uploadedList"
                                    :key="i"
                                  >
                                    <v-list-item-icon>
                                      <v-btn color="primary" icon @click="copy(item)">
                                          <v-icon>file_copy</v-icon>
                                      </v-btn>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title v-text="item.name"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-icon>
                                      <v-btn color="primary" icon @click="removeFileFromList(item, i)">
                                          <v-icon>delete</v-icon>
                                      </v-btn>
                                    </v-list-item-icon>
                              </v-list-item>
                        </v-list>
                      </v-col>
                </v-row>
             </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="padding:5px;padding-right:10px;">
          <v-btn
            color="darken-1"
            text
            @click.prevent="dialogUploadList = false">
            close
          </v-btn>
          <div class="flex-grow-1"></div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 sm12>

         <app-header   v-if="headerState" :hideTitle="!titleState">
            <span slot="title">Drop</span>
            <span slot="right">
              <v-btn class="btn_json" @click="newFile" icon >
                  <v-icon>insert_drive_file</v-icon>
              </v-btn>
            </span>
         </app-header>
            <v-row no-gutters justify="start"  align="center" align-content="center">
                <v-col cols="auto" class="d-flex align-center" style="margin-left:10vw;height:40px">
                  <v-checkbox class="mt-0" hide-details="true" v-model="toSS" label="Drop to smartscreen"></v-checkbox>

                </v-col>
                <v-col cols="auto" class="d-flex align-center ml-4">
                  <v-text-field v-if="toSS" hide-details="true" dense outlined label="Target" v-model="ssTarget"></v-text-field>
                </v-col>
                <v-col cols="12" class="mt-5 d-flex justify-center" style="height:60vh">
                <div id="dropzone-box">
                   <vue-dropzone ref="objstore" id="dropzone"
                    @vdropzone-complete="uploadComplete"
                    @vdropzone-success="uploadSuccess"
                    @vdropzone-removed-file="removeFile"
                    @vdropzone-file-added="fileAdded"
                    v-on:vdropzone-sending="sendingEvent"
                    :options="dropzoneOptions"
                    duplicateCheck
                    >
                    </vue-dropzone>
                    <!-- <v-row style="margin-top:20px;" justify="center"  align="center">
                        <v-btn class="dialog_btn" color="primary" text @click="upload">
                          Upload
                        </v-btn>
                    </v-row> -->
                    <v-row v-if="uploadedList.length > 0" style="margin-top:10px;" justify="center"  align="center">
                       <v-btn class="dialog_btn" color="primary" text @click="dialogUploadList = true">
                          Show Uploaded List
                        </v-btn>
                       <!-- <div v-if="dataChanged.url">
                        Download Link : <a :href="dataChanged.url" target="_blank">{{dataChanged.url}}</a>
                      </div>
                      <v-btn v-if="dataChanged.url" class="dialog_btn" color="primary" text @click="copy">
                        Copy Link
                      </v-btn> -->
                    </v-row>
              </div>
              </v-col>
            </v-row>

    </v-flex>
  </v-layout>
</template>
<script>
import { setTimeout, setInterval } from 'timers';
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import conf from '@/config/config';
import { mapGetters } from 'vuex';

export default {
    id: "#drop",
    props: ['pageParams'],
    data () {
      return {
        dialogUploadList: false,
        toSS:false,
        ssTarget:'',
        uploadedList: [],
        uploadedFileList: [],
        dataChanged: { bucket: 'upload', url: null},
        dropzoneOptions: {
          url: conf.objstoreurl + '/api/object/upload',
          thumbnailWidth: 170,
          maxFilesize: 200,
          maxFiles: 6,
          addRemoveLinks: true,
          // autoProcessQueue: false,
          // autoDiscover: false,
          headers: {
            'Access-Control-Allow-Origin': '*'
          },
        },
        snakText: '',
        snackbar: false,
        errorMsg: '',
        error: false,
        eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
        },
        webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
        },
        loading: false,
        mmsReady: false,
        mms: null
      }
    },
    mounted: function() {
    console.log(this.$refs);
    },
    async created() {
       this.startMMS();
    },
    async beforeMount() {
       await this.subscribeMMS();
    },
    beforeDestroy() {
      this.removeEvent();
    },
    components: {
      vueDropzone: vue2Dropzone
    },
    computed: {
      ...mapGetters([
        'headerState',
        'footerState',
        'titleState'
      ]),
      getData() {
        return this.data || {};
      },
      getDialog(){
        return this.dialog;
      }
    },
    methods: {
      close() {
        this.$emit('closeDialog', false);
      },
      newFile() {
        this.dataChanged = {bucket: 'upload', url: null};
        this.uploadedList = [];
        this.$refs.objstore.removeAllFiles();
      },
      copy: async function(item) {
        this.snakText = 'Download link copied.';
        this.snackbar = true;
        let url = item.url ? (item.url.indexOf("?") > -1 ? item.url.substring(0, item.url.indexOf("?")) : item.url) : null;
        if(url)
        await navigator.clipboard.writeText(url);
      },
      removeAllFiles(){
        this.uploadedList = [];
        this.$refs.objstore.removeAllFiles(true);
      },
      fileAdded(file){
          //this.uploadedFileList.push(file);
      },
      manuallyAddFile(obj, item){
          this.$refs.objstore.manuallyAddFile(obj, item);
      },
      upload() {
        this.uploadedList = [];
        this.$refs.objstore.processQueue();
      },
      async uploadSuccess(file, response){
        console.log(file);
        console.log(response);
        if(response.ErrMsg == 'OK'){
          this.uploadedList.push({name: file.name, url: response.Data});
          if(this.toSS){
            let reply=await this.mms.sendMMS({
              topic: 'ss://drop',
              DDN: `>>${this.ssTarget}`,
              payload: {"cmd":"drop","type":"url","src":[response.Data]}
            })
            console.log(reply);
          }
        }else{
           this.errorMsg = response.ErrMsg;
           this.error = true;
        }
      },
      uploadComplete(response){
        // if(response.status == "success"){

        //   this.$emit('objectData', this.dataChanged);
        // }
      },
      removeFile(file, error, xhr){
        if(this.uploadedList.length > 0)
          this.removeFileMMS({name: file.name});
      },
      async removeFileFromList(file, index){
        let result = await this.removeFileMMS({name: file.name});
        if(result == 'OK')
          this.uploadedList.splice(index, 1);
      },
      sendingEvent(file, xhr, formData){
        //formData.append('object', this.dataChanged.object);
        formData.append('bucket', this.dataChanged.bucket);
      },
      async removeFileMMS(item){
          let payload;

          payload = {
              bucket: this.dataChanged.bucket,
              object: item.name
          }


          if(!this.checkWebMMSState())
            return;

          this.isLoading = true;

          let res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "file://delete",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                    let index = this.uploadedList.findIndex(x => x.name == item.name);
                    this.uploadedList.splice(index, 1)
                    return result.Reply.ErrMsg
                }else{
                  return result.Reply.ErrMsg;
                }
            }

      },
       checkWebMMSState(){
        if(!this.mmsReady)
        {
          this.errorMsg = "WebMMS is not connected or registered.";
          this.error = true;
          return false;
        }else return  true;

      },
      startMMS(){
          this.mms =  webmms({
            wsurl: conf.wsurl,
            EiToken: getCookie("drp-EiToken") || "",
            SToken: getCookie("drp-SToken") || ""
          });
      },
      async subscribeMMS() {
        this.removeEvent = this.mms.on("registered", async reply => {
            //console.log('reply=%s', JSON.stringify(reply))
             if(reply.ErrMsg == "OK"){
                this.eiInfo.ddn = reply.result.DDN;
                this.webmmsOptions.EiToken = reply.result.EiToken;
                this.webmmsOptions.SToken = reply.result.SToken;
                this.webmmsOptions.UToken = reply.result.UToken;
                this.mmsReady = true;
                this.error = false;
             }else{
                this.mmsReady = false;
                this.error = false;
             }

             let expiredTime = 60 * 60 * 24 * 30 * 12;

             setCookie("drp-EiToken", this.webmmsOptions.EiToken);
             setCookie("drp-SToken", this.webmmsOptions.SToken);


             console.log('regtoCenter: %s', reply.ErrMsg);
             await this.track(this.mms, 'drop', this.pageParams);


        });

        this.mms.on('message', (method, from, data, body) => {
             this.mmsReady = true;
             this.error = false;
             console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
            if(typeof data == 'object' && !data.from)
              data.from = from;
            //body.sender = data;
            if(data)
            {

              //this.eventList.push(data.data);
              //this.setLog({From : from, Data: data}, 'In');

            }
        });

        this.mms.on('state', msg => {
            console.log('WS error: %s', msg);
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('disconnect', msg => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('error', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_error', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });

        this.mms.on('connect_timeout', err => {
            this.mmsReady = false;
            this.error = true;
            this.loading = false;
        });
      },
    }

  }
</script>
<style scoped>
.headline{
    font-size: 12pt !important;
    color: #056e97;
    font-weight: bold;
    padding-bottom: 0;
}
#dropzone-box{
  height: 80%;
  min-height: 80%;
  width: 80%;
}
#dropzone{
  min-height: 80%;
  width: 100%;
}
</style>


